import { memoize } from './function'

export const max = (array: number[]): number => Math.max.apply(null, array)

export const min = (array: number[]): number => Math.min.apply(null, array)

export const cloneArray = (array) =>
  array && Array.isArray(array) ? array.slice(0) : undefined

export const createArray = memoize((n) => Array.from(Array(n).keys()))
